import { IRootState } from '@/store'
import { ActionContext } from 'vuex'

export interface ILoyaltyBannerImage {
    id: string,
    link: string,
    name: string
}

export interface ILoyaltyBrand {
    brandName: any
    name: string,
    body: string,
    brandlogo: {
        link: string
    },
    brandImage: object,
    bannerImage: ILoyaltyBannerImage,
    programImage: ILoyaltyBannerImage,
    programPdf: ILoyaltyBannerImage,
    regulationPdf: ILoyaltyBannerImage,
    programTitle: string,
    hectolitersKegForVoucher: string
}

export interface ILoyaltyProgram {
    loyaltyBrands: ILoyaltyBrand[],
    loyalityPageImage: ILoyaltyBannerImage
}

export enum ILoyaltyActionsTypes {
    'FETCH_LOYALTY_PROGRAM' = 'FETCH_LOYALTY_PROGRAM',
    'FETCH_LOYALTY_BRAND' = 'FETCH_LOYALTY_BRAND',
    'FETCH_LOYALTY_RESULT' = 'FETCH_LOYALTY_RESULT'
}

export enum ILoyaltyMutationTypes {
    'SET_LOADING' = 'SET_LOADING',
    'SET_LOYALTY_PROGRAM' = 'SET_LOYALTY_PROGRAM',
    'SET_LOYALTY_BRAND' = 'SET_LOYALTY_BRAND',
    'SET_RESULT' = 'SET_RESULT'
}

export interface ILoyaltyState {
    loading: boolean,
    program: ILoyaltyProgram,
    brands: ILoyaltyBrand[],
    results: Array<any>[]
}

export type ILoyaltyMutation<S = ILoyaltyState> = {
    [ILoyaltyMutationTypes.SET_LOADING](state: S, payload: boolean): void
    [ILoyaltyMutationTypes.SET_LOYALTY_PROGRAM](state: S, payload: any): void
}

export type AugmentedAuthActionType = {
    commit<K extends keyof ILoyaltyMutation>(
      key: K,
      payload: Parameters<ILoyaltyMutation[K]>[1]
    ): ReturnType<ILoyaltyMutation[K]>
  } & Omit<ActionContext<ILoyaltyState, IRootState>, 'commit'>

export type ILoyaltyAction = {
    [ILoyaltyActionsTypes.FETCH_LOYALTY_PROGRAM]({ commit }: AugmentedAuthActionType, payload: any): void
}
